import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDrawer4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"drawer-4"} maskId="square-filled-radius-0-stroke-1-IconDrawer4"><path fillRule="evenodd" clipRule="evenodd" d="M11.5 4H2V17H4L4 20H5L5 17H11.5V4ZM10 12V8H9V12H10Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M12.5 17H19V20H20V17H22V4H12.5V17ZM15 8V12H14V8H15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDrawer4;
